//This will be deprecated in the future, but the alternative is not fully support: https://erikmartinjordan.com/navigator-platform-deprecated-alternative
const isMacOS = () => {
  return navigator.platform.indexOf('Mac') === 0
}

export const IS_MAC_OS = isMacOS()
